__turbopack_context__.v({
  "data": "styles-module-scss-module__SlE5Ua__data",
  "data-disclosures": "styles-module-scss-module__SlE5Ua__data-disclosures",
  "data__item": "styles-module-scss-module__SlE5Ua__data__item",
});
